import { render, staticRenderFns } from "./employe-roles-dialog.vue?vue&type=template&id=1ddfd7ba&scoped=true"
import script from "./employe-roles-dialog.vue?vue&type=script&lang=js"
export * from "./employe-roles-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddfd7ba",
  null
  
)

export default component.exports